import ExcelImport from '@/core/helper/excel-import';
import { Config } from '@/core/config/config';

const uploadUrl = `${Config.VITE_APP_GATEWAY_URL}/api/product/product-group/upload-product-groups`
const templatePath = '/Upload_Product_Groups_Template.xlsx';
const UploadProductGroups = () => {
    return (
        <ExcelImport cardTitle='import-product-group' uploadUrl={uploadUrl} templatePath={templatePath}></ExcelImport>
    )
}
export default UploadProductGroups